<template>
  <div class="create-product">
    <!-- <el-breadcrumb class="my-breadcrumb" separator="/">
      <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 商品管理 </el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <!-- <div class="crumbs">
        <el-button @click="handleExport">导出</el-button>
      </div> -->
      <div>
        <E-Table
          :loading="loading"
          :table-data="tableData"
          :table-label="tableLabel"
          :indexShow="true"
        >
         
         
         
          <template v-slot:operation="slot">
            <el-button
              type="text"
              class="btn-txt margin-r10"
              @click="handleEditDialog(slot.scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              class="btn-txt margin-r10"
              @click="goToUrl('./supplierDetail', slot.scope.row)"
              >详情</el-button
            >
            <el-button
              type="text"
              class="btn-txt"
              @click="goToUrls('/orderManageCaiGou', slot.scope.row)"
              >订单</el-button
            >
          </template>
        </E-Table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="listQuery.pageNum"
            :total="total"
            :page-size.sync="listQuery.pageSize"
            prev-text="上一页"
            next-text="下一页"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from "../../../api/product";
import ESearch from "@/modules/projectA/components/common/e-search.vue";
import ETable from "@/modules/projectA/components/common/e-table-list.vue";
import utils from "../../../utils/utils";
import { mapMutations } from "vuex";
export default {
  /* name: 'goodsMaintenance', */
  components: {
    ETable,
    ESearch,
  },
  props: {},
  data() {
    return {
      loading: false,
      minOrderQuantity: 1,
      editVisible: false,
      supplierCategoryVisible: false,
      searchCategoryVisible: false,
      scoreVisible: false,
      categoryTreeData: [],
      supplierCategoryTreeData: [],
      defaultCheckedKeys: [],
      startDate: "",
      endDate: "",
      // 本页面参数
      filterInfo: {
        fieldList: [
          { label: "物料描述", type: "input", value: "materialDesc" },
          { label: "库存地", type: "input", value: "stockStorageName" },
          { label: "物料规格", type: "input", value: "specifications" },
        //   {
        //     label: "供应商分级",
        //     type: "select",
        //     value: "supplierLevel",
        //     list: "levelList",
        //   },
        //   { label: "产品目录", type: "dialog", value: "categoryName" },
        
          {
            label: "专业分类",
            type: "select",
            value: "stockClassify",
            list: "classifyList",
          },
          {
            label: "更新时间",
            type: "date",
            value: "addTime",
            dateType: "daterange",
            valueFormat: "yyyy-MM-dd",
            // TimePickerOptions: {
            //   onPick: (obj) => {

            //     this.startDate = new Date(obj.minDate).getTime(); //获取你第一次点击的日期
            //     this.endDate = new Date(obj.maxDate).getTime(); //获取你第二次点击的日期
            //   },
            //   disabledDate: (time) => {
            //     if (this.startDate && !this.endDate) {
            //     //   const timeZone = 365 * 24 * 3600 * 1000; //1年
            //       let maxTime = this.startDate;
            //       let minTime = this.startDate;
            //       let limitDate =
            //         time.getTime() > maxTime || time.getTime() < minTime;
            //       return limitDate;
            //     } else {
            //       return "";
            //     }
            //   },
            // },
          },
        ],
        count: 100,
        btnStyle: [
          { icon: "el-icon-search", text: "搜索", type: "primary" },
          { icon: "el-icon-refresh", text: "重置" },
        ],
      },
      opentimePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 86400000;
        },
      },
      listTypeInfo: {
        classifyList: [
           {id:"",name:'全部行业'},
            {id:1,name:'化工'},
            {id:2,name:'电仪'},
            {id:3,name:'材料'},
            {id:4,name:'技术'},
            {id:5,name:'煤炭'},
            {id:6,name:'设备'},
        ],
        /* {
    key: 1,
    value: "全平台",
  },
  {
    key: 2,
    value: "仅协议客户",
  }, */
      },
      idKey: "skuId",
      // 列表搜索
      listQuery: {
        materialDesc: null,
        stockStorageName: null,
        specifications: null,
        addTime: [],
        stockClassify: "",
      },
      queryParams: {
        materialDesc: null,
        stockStorageName: null,
        specifications: null,
        pageNum: 1,
        pageSize: 10,
        stockClassify: "",
        startTime:null,
        endTime:null,
        supplierCompanyFlag:0
      },
      cloneListQuery: {},
      total: 0,
      tableLoading: false,
      tableData: [{}],
      tableLabel: [
        {
          label: "供应商名称",
          align: "center",
          param: "supplyName",
          // width: "60",
        },
        {
          label: "石化编码",
          param: "companyCode",
          align: "center",
          minWidth: "100",
        },
        {
          label: "物料描述",
          param: "materialDesc",
          align: "center",
          minWidth: "200",
        },
        {
          label: "规格名称",
          param: "specifications",
          align: "center",
          minWidth: "130",
        },
        {
          label: "库存数量",
          align: "center",
          param: "stockQuantity",
          minWidth: "160",
        },
        {
          label: "计量单位",
          param: "eachUnit",
          align: "center",
          minWidth: "130",
        },
        {
          label: "专业分类",
          param: "stockClassify",
          align: "center",
          minWidth: "130",
        },
        {
          label: "类别名称",
          param: "stockCategoryName",
          align: "center",
          minWidth: "130",
        },
        {
          label: "库存所属单位",
          param: "stockCompany",
          align: "center",
          minWidth: "130",
        },
        {
          label: "库存所在省市",
          param: "stockCity",
          align: "center",
        },
        {
          label: "库存地",
          param: "stockStorageName",
          align: "center",
        },
        {
          label: "库存标记",
          param: "stockFlag",
          align: "center",
           render: (item) => {
            let str = "";
            switch (item.stockFlag) {
              case 1:
                str = "账面";
                break;
              case 0:
                str = "实物";
                break;
              default:
                str = "";
                break;
            }
            return str;
          },
        },
        {
          label: "供应商联系人",
          param: "supplyLinkman",
          align: "center",
        },
        {
          label: "联系电话",
          param: "supplyPhone",
          align: "center",
        },
         {
          label: "框架协议号",
          param: "stockDealNbr",
          align: "center",
        },
         {
          label: "更新时间",
          param: "updateTime",
          align: "center",
        },
      
        // {
        //   label: "操作",
        //   align: "center",
        //   slot: "operation",
        //   width: "160",
        // },
      ],
      // 选中的列表数据
      multipleSelection: [],
      multipleSelectionAll: [],
      supplierInfo: {},
    };
  },
  created() {
    // this.queryParams.companyId = this.$store.state.USERINFO.companyId;
    this.cloneListQuery = { ...this.queryParams };
    this.getAllList(this.queryParams);
  },
  mounted() {
    // this.getProvinceList();
  },
  methods: {
    ...mapMutations(["getSupplierScoreInfo"]),
    // //获取省列表
    // async getProvinceList() {
    //   let res = await api.queryByParentId();
    //   if (parseInt(res.code) === 200) {
    //     let data = res.data;
    //     data.map((item) => {
    //       item.id = item.areaId;
    //       item.name = item.areaName;
    //     });
    //     this.listTypeInfo.areaList = data;
    //   }
    // },
    handleEditDialog(row) {
      this.supplierInfo = {};
      for (let key in row) {
        this.$set(this.supplierInfo, key, row[key]);
      }
      this.editVisible = true;
    },

    // 所属分类确定
    classifySubmitPopupData(val) {
      let filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.listQuery.productCatalog = filterNode.map((item) => item.categoryId);
      let arr = val.map((item) => item.categoryName);
      this.listQuery.categoryName = arr.join("、");
      this.searchCategoryVisible = false;
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.searchCategoryVisible = false;
    },
    // 编辑供应商保存
    async handleEdit(val) {
      console.log(val);
      let res = await api.saveSupplierInfo(val);
      if (parseInt(res.code) === 200) {
        this.editVisible = false;
        this.getAllList(this.queryParams);
      } else {
        this.editVisible = false;
      }
    },
    //see category
    handleCategoryDialog(row) {
      this.getSupplierCategoryList(row.supplierId);
      this.supplierCategoryVisible = true;
    },
    //judge score
    async handleScoreDialog(row) {
      this.$refs.score.setTableDataScore(row);
      this.scoreVisible = true;
    },
    scoreResetPopupData() {
      this.scoreVisible = false;
    },
    // 提交评分
    async scoreSubmitPopupData(options) {
      console.log(options);
      let params = {};
      options.data.map((item) => {
        params[item.type] = item.grade;
      });
      params.compositeScore = options.score;
      params.supplierId = options.supplierId;
      params.companyId = options.companyId;
      params.id = options.id;
      console.log(params);
      let res = await api.saveSupplierScore(params);
      if (res.code === "200") {
        this.getAllList(this.queryParams);
        this.scoreVisible = false;
      }
    },
    // 获取供应商信息列表
    async getAllList(params) {
      this.tableData = [];
      try {
        this.tableLoading = true;

        const res = await api.queryStoreInfo(params);
        this.tableLoading = false;
        if (res.code === "200") {
          const data = res.data;
          this.tableData = [...data.records];
          // this.tableData = [{}]
          this.total = data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async handleExport() {
      let params = this.queryParams;
      let res = await api.downloadSupplierList(params);
      if (res.type == "application/json") {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res);
      }
    },

    // 跳转链接
    goToUrl(url, row = {}) {
      // this.$store.commit('getSupplierScoreInfo',row)
      console.log(utils.isEmptyObject(row));
      if (utils.isEmptyObject(row)) {
        this.$router.push({
          path: url,
        });
      } else {
        this.getSupplierScoreInfo(row);
        const { supplierId = "" } = row;
        this.$router.push({
          path: url,
          query: { supplierId: supplierId },
        });
      }
    },
    goToUrls(url, row = {}) {
      this.$router.push({
        path: url,
        query: { supplier: row.supplier },
      });
    },
    async getSupplierCategoryList(id) {
      let res = await api.querySupplierProductCatalogInfo(id);
      if (parseInt(res.code) === 200) {
        this.supplierCategoryTreeData = res.data;
      }
    },

    //
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getAllList(this.queryParams);
    },
    // 改变条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = val;
      this.getAllList(this.queryParams);
    },
    // 列表搜索
    handleSearch(val) {
      console.log(val);
      let classifyList = this.listTypeInfo.classifyList;
      for (let i = 0; i < classifyList.length; i++) {
        if (classifyList[i].id == val.stockClassify) {
          val.stockClassify = classifyList[i].name;
          break;
        }
      }
      for (let key in val) {
        if (key === "addTime") {
          this.queryParams.startTime =
            val[key].length > 1 ? val[key][0] + " " + "00:00:00" : null;
          this.queryParams.endTime =
            val[key].length > 1 ? val[key][1] + " " + "23:59:59" : null;
        }
        //  else if(key === "area"){

        // }
        else {
          this.queryParams[key] = val[key];
        }
      }
      this.queryParams.pageNum = 1;
      console.log(this.queryParams);
      this.getAllList(this.queryParams);
    },
    // 列表搜索重置
    handleReset(val) {
      console.log(val);
    //   this.listQuery.categoryName = null;
      this.queryParams = { ...this.cloneListQuery };
    //   this.queryParams.categoryName = null;
      this.getAllList(this.queryParams);
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.create-product {
  .text-btn {
    color: #0263c9;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;
    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }
  .wrapper {
    margin-top: 20px;
    background: #fff;
  }
  .search-box {
    background: #fff;
    padding: 10px;
  }

  .handle-box {
    white-space: nowrap;
    background: #fff;
    margin-top: 20px;
    padding: 0 20px;
    min-height: 32px;
    .delete {
      color: #c5c5c5;
    }
  }
  .table-box {
    padding: 10px;
    overflow: hidden;
  }
  .pagination-box {
    text-align: right;
    margin-top: 10px;
  }
}
</style>
<style>
.el-tooltip__popper {
  max-width: 320px;
}
</style>
